<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="20%" top="15%" class="dialogstyle">
      <div slot="title" class="title">
        {{ $t("myPage.getBackwater") }}
      </div>
      <div class="content">
        <p class="p1">
          ￥{{ $common.setNumFixed(userfan.rebateAmount, 2) }}
        </p>
        <p class="p2">
          {{ $t("myPage.requirements") }}
          {{ userfan.verityCount }}
          {{ $t("myPage.Times") }}
        </p>

        <div class="btnBox">
          <el-button round class="btnPrevious buttonHover2" @click="goUrlsee">
            {{ $t("myPage.see") }}</el-button>
          <el-button round class="btn buttonHover1" @click="onSubmit">
            {{ $t("myPage.once") }}</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogFan" width="20%" top="15%" class="dialogstyle">
      <div slot="title" class="title">
        <!-- <img loading="lazy"
                    v-lazy="require('../../../assets/image/dze/success.png')"
                    class="successImg"
                    alt
                /> -->
        {{ $t("myPage.tipstitle") }}
      </div>
      <div class="content">
        <p class="p1">{{ $t("myPage.titleAlert") }}</p>
        <p class="text-t">
          {{ $t("myPage.tipsRes") }}
        </p>

        <div class="btnBox">
          <el-button round class="btn buttonHover1" @click="dialogFan = false">
            {{ $t("myPage.know") }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    userfan: Object,
  },
  data() {
    return {
      dialogVisible: false,
      dialogFan: false,
      // userfan: {},
    };
  },
  methods: {
    // 返水领取查看详情
    goUrlsee() {
      this.dialogVisible = false;
      this.$router.push(`/my/tradingRecord?type=${new Date().getTime()}`);
    },
    onSubmit() {
      this.$http
        .get(
          this.$api.receiveRebate +
          this.$cache.get("set_user").user_id
        )
        .then((res) => {
          if (res.code == 0) {
            this.dialogVisible = false;
            this.dialogFan = true;
            this.$emit("onbackFan");
            // this.getuserFanshui();
          }
        });
    },
    // 获取返利
    getuserFanshui(type) {
      this.$http
        .get(
          this.$api.getRebateAmount +
          this.$cache.get("set_user").user_id
        )
        .then((res) => {
          if (res.code == 0) {
            this.userfan = res.data;
            if (type) {
              this.$message({
                message: this.$t("myPage.success"),
                type: "success",
              });
            }
          } else {
            if (type) {
              this.$message({
                message: this.$t("myPage.failure"),
                type: "warning",
              });
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" >
.dialogstyle {
  .el-dialog__header {
    padding: 20px 20px 10px;
  }
  .title {
    color: #313131;
    font-size: 0.24rem;
    font-weight: bold;
    text-align: center;
    .successImg {
      width: 0.47rem;
      height: 0.47rem;
    }
  }
  .content {
    text-align: center;
    .p1 {
      color: #313131;
      font-size: 24px;
    }
    .p2 {
      color: #313131;
      font-size: 24px;
    }
    .text-t {
      color: #313131;
      opacity: 0.5;
      font-size: 0.15rem;
    }
  }
  .btnBox {
    text-align: center;
    margin-top: 0.4rem;
    .btnPrevious {
      border: 1px solid #ff3a2b;
      border-radius: 10px;
      color: #ff3a2b;
      font-size: 0.16rem;
      text-align: center;
      background: #fff;
      width: 1.2rem;
    }
    .btn {
      color: #fff;
      font-size: 0.16rem;
      border: none;
      width: 1.2rem;
      background: #ff3a2b;
      border-radius: 10px;
      line-height: 1;
    }
  }
}
</style>